import Vue from "vue";

// 生成一个vue实例用作 事件交换 （event bus）
export default new Vue();